// Empire Jamaica Fusion — Menu Data
// Source of truth: official to-go menu (Dec 2025).
// L = Lunch · D = Dinner · V = Vegan · GF = Gluten-Free

export const SPECIALS = {
    lunch: {
        title: "Lunch Special",
        price: "$8.99",
        eyebrow: "Mon – Fri · 11AM – 2PM",
        note: "Chicken meals only.",
    },
    vegan: {
        title: "Vegan Lunch Special",
        price: "$10.99",
        eyebrow: "Mon – Fri · 11AM – 2PM",
        note: "Stew meals only.",
    },
};

export const MENU = [
    {
        id: "entrees",
        eyebrow: "Heart of the Kitchen",
        title: "Entrées",
        note: "Each entrée served with Gungo Peas & Rice, sautéed cabbage mixed with collard greens, and fried sweet plantains.",
        groups: [
            {
                heading: "Chicken",
                items: [
                    { name: "Jerk Chicken", price: "$13.99 / $17.99", meta: "L / D", desc: "A signature blend of herbs and spices marinated into tender chicken, grilled to perfection with authentic Jamaican flavor and a hint of heat." },
                    { name: "Curry Chicken", price: "$13.99 / $17.99", meta: "L / D", desc: "Tender chicken simmered in rich Jamaican curry sauce with garlic, onions, and potatoes for a comforting island classic." },
                    { name: "Brown Stew Chicken", price: "$14.99 / $18.99", meta: "L / D", desc: "Marinated chicken slow-cooked in savory brown gravy with onions, bell peppers, garlic, and traditional Caribbean seasonings." },
                    { name: "Fried Chicken", price: "$18.99", meta: "D", desc: "Crispy seasoned chicken fried until golden brown and served with authentic Jamaican flavor." },
                    { name: "Bourbon Chicken", price: "$18.99", meta: "D", desc: "Tender chicken glazed in a sweet and savory bourbon-inspired sauce with garlic and ginger." },
                    { name: "Honey Garlic Chicken", price: "$18.99", meta: "D", desc: "Tender chicken lightly fried and tossed in a rich honey garlic sauce, finished with fresh green onion." },
                ],
            },
            {
                heading: "Beef",
                items: [
                    { name: "Oxtail", price: "$26.99", meta: "D · slow-braised 2 hours", desc: "Slow-braised oxtail cooked until tender in rich gravy with butter beans, herbs, and savory spices." },
                ],
            },
            {
                heading: "Goat",
                items: [
                    { name: "Curry Goat", price: "$19.99", meta: "D · Fridays only", desc: "Tender goat meat simmered in authentic Jamaican curry sauce with garlic, onions, and traditional seasonings." },
                ],
            },
        ],
    },
    {
        id: "seafood",
        eyebrow: "From The Coast",
        title: "Fish & Shrimp",
        groups: [
            {
                heading: "Fish",
                items: [
                    { name: "Brown Stew / Escovitch Snapper", price: "Market Price", desc: "Fresh snapper prepared your way — simmered in rich brown gravy or topped with traditional escovitch vegetables and vinegar." },
                    { name: "Kingfish Brown Stew", price: "$24.99", desc: "Island-style kingfish simmered in rich brown gravy with onions, peppers, herbs, and spices." },
                    { name: "Escovitch Tilapia / Kingfish", price: "$21.99", desc: "Fresh fish seasoned and fried, then topped with traditional escovitch vegetables and vinegar." },
                    { name: "Ginger Soy Glazed Salmon", price: "$24.99", desc: "Fresh salmon glazed with a savory ginger soy sauce, creating the perfect balance of sweet and bold flavor." },
                    { name: "Fried Whiting / Tilapia", price: "$21.99", desc: "Lightly seasoned fish fried until golden, crispy, and flaky." },
                ],
            },
            {
                heading: "Shrimp",
                items: [
                    { name: "Jerk Shrimp", price: "$21.99", desc: "Fresh shrimp seasoned with house jerk spices and grilled with bold Scotch bonnet flavor." },
                    { name: "Curry Shrimp", price: "$21.99", desc: "Jumbo shrimp sautéed with colorful peppers and finished in a rich Jamaican curry sauce." },
                    { name: "Garlic Shrimp", price: "$21.99", desc: "Jumbo shrimp sautéed in a savory garlic sauce with peppers and onions." },
                    { name: "Fried Shrimp", price: "$22.99", desc: "Lightly breaded shrimp fried golden and served crispy." },
                    { name: "Coconut Shrimp", price: "$24.99", featured: true, desc: "Crispy shrimp coated in coconut and fried until golden with a sweet island finish." },
                ],
            },
        ],
    },
    {
        id: "vegan",
        eyebrow: "Plant-Forward",
        title: "Vegan",
        note: "Real Caribbean cuisine, fully plant-based — slow-cooked, deeply spiced, no shortcuts.",
        groups: [
            {
                heading: null,
                items: [
                    { name: "Curry Chickpea Stew", price: "$19.99", vegan: true, desc: "Slow-simmered chickpeas cooked in rich curry sauce with herbs and spices." },
                    { name: "Trini Jerk / BBQ Chickless", price: "$21.99 / $25.99", vegan: true, desc: "Plant-based protein prepared two ways — seasoned with bold Caribbean jerk spices and grilled, or tossed in a sweet and smoky BBQ sauce." },
                    { name: "Chickpea & Heart of Palm Cakes", price: "$22.99", vegan: true, featured: true, desc: "Crispy cakes made with chickpeas and heart of palm, seasoned with aromatic herbs and spices." },
                    { name: "Black Eyed Peas Savory Stew", price: "$19.99", vegan: true, desc: "Slow-cooked black eyed peas in a rich, flavorful vegetable stew." },
                ],
            },
        ],
    },
    {
        id: "sides",
        eyebrow: "On The Side",
        title: "Sides",
        groups: [
            {
                heading: null,
                items: [
                    { name: "Wicked Mac & Cheese", price: "$6.99", desc: "Creamy baked macaroni and cheese with rich homestyle comfort-food flavor." },
                    { name: "Gungo Peas & Rice", price: "$6.99", vegan: true, gf: true, desc: "Traditional Jamaican rice and peas cooked with coconut milk and savory seasonings." },
                    { name: "Fried Sweet Plantains", price: "$7.99", vegan: true, desc: "Sweet ripe plantains fried until caramelized and golden." },
                    { name: "Candied Yams", price: "$7.99", vegan: true, desc: "Sweet, tender yams slow-cooked with warm spices and a rich buttery glaze." },
                    { name: "Mashed Potatoes", price: "$3.99", vegan: true, desc: "Creamy mashed potatoes whipped until smooth and buttery." },
                    { name: "Steam White Rice", price: "$3.99", vegan: true, gf: true, desc: "Perfectly steamed white rice served light, fluffy, and fresh." },
                    { name: "Steam Brown Rice", price: "$3.99", vegan: true, gf: true, desc: "Perfectly steamed brown rice served light, fluffy, and fresh." },
                    { name: "Veggies", price: "$6.99", vegan: true, desc: "Fresh seasonal vegetables lightly seasoned and cooked to perfection." },
                    { name: "Collard Greens", price: "$7.99", vegan: true, desc: "Tender collard greens slow-cooked with garlic, onions, and savory seasonings for rich homestyle flavor." },
                ],
            },
        ],
    },
    {
        id: "patties",
        eyebrow: "Baked Fresh",
        title: "Patties",
        groups: [
            {
                heading: null,
                items: [
                    { name: "Beef Patty", price: "$3.99" },
                    { name: "Cheesy Beef Patty", price: "$3.99" },
                    { name: "Jerk Chicken Patty", price: "$3.99" },
                    { name: "Curry Chicken Patty", price: "$3.99" },
                    { name: "Vegetable Patty", price: "$3.99" },
                    { name: "Spinach Patty", price: "$3.99" },
                    { name: "Coco Bread", price: "$3.00" },
                ],
            },
        ],
    },
    {
        id: "sandwiches",
        eyebrow: "Handheld Favorites",
        title: "Sandwiches",
        groups: [
            {
                heading: null,
                items: [
                    { name: "Jerk Chicken Sandwich", price: "$11.99", desc: "Grilled chicken breast marinated in our signature jerk sauce and served on fresh coco bread with crisp lettuce and sliced tomato." },
                    { name: "Fish Fillet Sandwich", price: "$12.99", desc: "Crispy fried fish fillet seasoned with our signature herbs and spices, served on fresh coco bread with crisp lettuce and sliced tomato." },
                ],
            },
        ],
    },
    {
        id: "kids",
        eyebrow: "For The Little Ones",
        title: "Kid's Menu",
        groups: [
            {
                heading: null,
                items: [
                    { name: "Fried Whiting Bites", price: "$8.99", desc: "Bite-sized crispy fish pieces perfect for younger guests." },
                    { name: "Fried Chicken Tenders", price: "$8.99", desc: "Golden fried chicken tenders served hot and crispy." },
                    { name: "Baked Mac & Cheese", price: "$5.99", desc: "Creamy baked macaroni and cheese made fresh daily." },
                ],
            },
        ],
    },
    {
        id: "drinks",
        eyebrow: "Pour & Sip",
        title: "Beverages",
        groups: [
            {
                heading: "Beverages",
                items: [
                    { name: "Jamaican Soda", price: "$3.00" },
                    { name: "Snapple Juice", price: "$2.75" },
                    { name: "Tropical Rhythm Juice", price: "$4 / $6.99", meta: "Glass / Carafe", featured: true },
                    { name: "Diet / Pepsi Soda", price: "$2.25" },
                    { name: "Diet / Coca-Cola Soda", price: "$2.25" },
                    { name: "Ginger Ale / Sprite Soda", price: "$2.25" },
                    { name: "Orange Soda", price: "$2.25" },
                    { name: "100% Coconut Water", price: "$7.99" },
                    { name: "Water / S. Pellegrino", price: "$3" },
                    { name: "100% Apple / Cranberry Juice", price: "$2.50 / $3" },
                    { name: "Jamaican Coffee", price: "$4.50" },
                    { name: "Tea", price: "$1.25" },
                ],
            },
        ],
    },
    {
        id: "dessert",
        eyebrow: "Sweet Endings",
        title: "Dessert",
        groups: [
            {
                heading: null,
                items: [
                    { name: "Chocolate Cake", price: "$6.00", meta: "Per slice", desc: "Rich, moist chocolate cake layered with decadent chocolate flavor." },
                    { name: "Carrot Cake", price: "$6.00", meta: "Per slice", desc: "Classic carrot cake made with warm spices and finished with cream cheese frosting." },
                    { name: "Cheesecake", price: "$6.00", meta: "Per slice", desc: "Creamy New York-style cheesecake with a smooth, rich finish." },
                    { name: "Tres Leches Cake", price: "$6.00", meta: "Per slice", desc: "Light sponge cake soaked in three milks and topped with a delicate whipped finish." },
                ],
            },
        ],
    },
];

export const LEGEND = [
    { key: "V", label: "Vegan" },
    { key: "GF", label: "Gluten-Free" },
    { key: "L", label: "Lunch Meal" },
    { key: "D", label: "Dinner Meal" },
];
